export default {
    // 模块名称
    carAuthority: {
    // 按钮类
    button: {            
      reset: 'Reset',
      query: 'Query',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      view: 'Details',
      add: 'Add',
      edit: 'Edit',
      uninstall: 'Uninstall',
      back: 'Back',
      sync: 'Sync',
      delete: 'Delete',
      modify: 'Modify',
      batchDeletion: 'Batch Deletion'
    },
    // 文字标签类
    label: {
    },
    // 提示类
    placeholder: {
      select: 'Select'
    },
    // 消息类
    message: {
        editSuccess: 'Edit successfully',
        editFailed: 'Edit failed',
        nospace: 'System name cannot contain spaces',
        ipformat: 'IP format is incorrect',
        systemname: 'Enter system name',
        less50: '1 to 50 characters in length',
        less200: '1 to 200 characters in length',
        ip: 'Enter ip',
        port: 'Enter port',
        port2: 'Enter correct port',
        account: 'Enter account',
        password: 'Enter password',
        vcn: 'Select vcn',
        uninstall: 'Are you sure to uninstall the system?',
        numberchar: 'Only enter numbers and letters',
        onlynumber: 'Only enter numbers',
        plugins: 'Select a plugin',
        domain: 'Enter domain code',
        deltips: 'Please select the device you want to delete',
        deltips2: 'Are you sure to delete the device?',
        delsuccess: 'Delete successfully',
        delfail: 'Delete failed',
        secretkey: 'Enter a secret key',
        nodata: 'No data',
        type: 'Alarm type cannot be empty',
    },
    // 标题类
    title: {            
      warn: 'Warning',
      uninstall: 'Uninstall',
      noData: 'No data',
    }
  }
}
